"use strict";

var chunkArray = function chunkArray(array, chunkSize) {
  var result = [];
  for (var i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }
  return result;
};
var appendSearchResults = function appendSearchResults(ul, liChunks, chunkNbr, button) {
  if (liChunks.length === chunkNbr + 1) button.style.display = 'none';
  return liChunks[chunkNbr].flat().map(function (li) {
    return ul.appendChild(li);
  });
};
document.addEventListener('DOMContentLoaded', function () {
  var categoryElements = Array.from(document.getElementsByClassName('js-category'));
  if (categoryElements.length !== 0) {
    categoryElements.forEach(function (category) {
      var _categoryChildren$fil, _categoryChildren$fil2;
      var categoryChildren = Array.from(category.children);
      var ulElement = (_categoryChildren$fil = categoryChildren.filter(function (childElement) {
        return childElement.nodeName === 'UL';
      })[0]) !== null && _categoryChildren$fil !== void 0 ? _categoryChildren$fil : null;
      var buttonElement = (_categoryChildren$fil2 = categoryChildren.filter(function (childElement) {
        return childElement.nodeName === 'BUTTON';
      })[0]) !== null && _categoryChildren$fil2 !== void 0 ? _categoryChildren$fil2 : null;
      if (ulElement && buttonElement) {
        var loadChunkNbr = 0;
        var liChunkSize = 5;
        var liElements = Array.from(ulElement.children);
        var liElementsChunked = chunkArray(liElements, liChunkSize);
        ulElement.innerHTML = '';
        appendSearchResults(ulElement, liElementsChunked, loadChunkNbr, buttonElement);
        buttonElement.addEventListener('click', function () {
          loadChunkNbr = loadChunkNbr + 1;
          appendSearchResults(ulElement, liElementsChunked, loadChunkNbr, buttonElement);
          var nextActiveElement = liElementsChunked[loadChunkNbr][0].querySelector('.a-btn--default');
          nextActiveElement.focus();
        });
      }
    });
  }
});